module.exports = __webpack_public_path__ + "img/bgDesenvolvimento.70e87242.png";